import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

// ClubStats (MyClubtap partner API) import. ClubStats only serves the club's current season, so
// there is no scope to send - only an optional team filter.
const getLink = async () => {
  const response = await agent.get(`${API_URL}clubstats/link`)
  return response.data
}
const saveLink = async (data) => {
  const response = await agent.post(`${API_URL}clubstats/link`, data)
  return response.data
}
const removeLink = async () => {
  const response = await agent.post(`${API_URL}clubstats/unlink`)
  return response.data
}

// Body: grade_ids (ClubStats ids), active. Deactivated grades are left out of the other tabs.
const setGradesActive = async (data) => {
  const response = await agent.post(`${API_URL}clubstats/grades/active`, data)
  return response.data
}

const preview = async (type, data) => {
  const response = await agent.post(`${API_URL}clubstats/preview/${type}`, data)
  return response.data
}
const runImport = async (type, data) => {
  const response = await agent.post(`${API_URL}clubstats/import/${type}`, data)
  return response.data
}

const ClubStatsService = {
  getLink,
  saveLink,
  removeLink,
  setGradesActive,
  preview,
  runImport,
}

export default ClubStatsService
